import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AuthProxyService } from '../../authentication/auth-proxy.service';

@Component({
  selector: 'fl-switch-user-dialog',
  templateUrl: './switch-user-dialog.component.html',
  styleUrls: ['./switch-user-dialog.component.scss'],
})
export class SwitchUserDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  get employeeIdCtrl() {
    return this.form.get('employeeId') as UntypedFormControl;
  }

  constructor(
    private _fb: UntypedFormBuilder,
    private _authProxy: AuthProxyService,
    private _dialogRef: MatDialogRef<SwitchUserDialogComponent>,
  ) {}

  public ngOnInit() {
    this.form = this._fb.group({
      employeeId: [null, Validators.required],
    });
  }

  public async submit() {
    const personId = this.employeeIdCtrl.value as string | null;
    if (personId != null) {
      await this._authProxy.impersonateUser(personId);
    }

    this._dialogRef.close();
    window.location.reload();
  }
}
